import { upperCase } from 'lodash';
import { Link } from 'react-router-dom';
import text from '../../../text';
import { type ActivityMetadata } from '@larki/shared/types/activity.type';
import { JobT } from '@larki/shared/types/job.type';
import { UserT } from '@larki/shared/types/user.type';
import QuoteCreated from '../QuoteActivityTemplates/QuoteCreated';
import RequestForQuote from '../QuoteActivityTemplates/RequestForQuote';
import InvoiceActivity from '../InvoiceActivity';
import { toCombinedQuote } from './utils';

const ActivityTemplate = ({
  metadata,
  job,
  createdUser,
}: {
  metadata: ActivityMetadata;
  job: JobT;
  createdUser: UserT;
}) => {
  switch (metadata.variant) {
    case 'quote_created': {
      const combinedQuote = toCombinedQuote(metadata.quote_data);
      const hasGetQuoteItems =
        Object.values(combinedQuote.nonRfq.composition).length > 0;
      return (
        <QuoteCreated
          title={'QUOTE CREATED'}
          quote={combinedQuote}
          job={job}
          softwareId={metadata.softwareId}
          layoutSwitch={{
            isSoftwareHidden: false,
            isTermsHidden: hasGetQuoteItems,
            isRfqNoteHidden: !hasGetQuoteItems,
          }}
          createdUser={createdUser}
        />
      );
    }
    case 'invoice':
      return <InvoiceActivity job={job} metadata={metadata} />;
    case 'payment_received':
      return (
        <>
          <p className='font-weight--600 mb-3 font-18 uppercase'>
            {text('paymentReceived')}
          </p>
          <Link
            className='font-weight-bold'
            style={{ textDecoration: 'underline' }}
            key='viewPaymentReceipt'
            to={{ pathname: metadata?.receipt_url }}
            target='_blank'
          >
            {text('viewPaymentReceipt')}
          </Link>
        </>
      );
    case 'request_for_quote':
      return (
        <RequestForQuote
          title={upperCase(text('requestForQuote'))}
          quote={metadata.request_for_quote_data}
          requestForQuoteId={metadata.request_for_quote_id}
          job={job}
          layoutSwitch={{
            isSoftwareHidden: true,
          }}
          createdUser={createdUser}
        />
      );
    default:
      return null;
  }
};

export default ActivityTemplate;
